<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <span
        class="el-spinner"
        :class="[
            `el-spinner--size-${size}`,
            `el-spinner--color-${color}`
        ]"
    />
</template>

<script setup>
defineProps({
    size: {
        type: Number,
        default: 16,
        validator: (prop) => [16, 24, 32, 48].includes(prop),
    },
    color: {
        type: String,
        default: 'brand-primary',
        validator: (prop) => ['white', 'brand-primary', 'brand-secondary', 'inversed-primary'].includes(prop),
    },
});
</script>

<style scoped lang="postcss">
.el-spinner {
    display: inline-block;
    vertical-align: middle;
    border-top-color: transparent !important;
    border-style: solid;
    border-radius: 50%;
    &--inversed-primary {
        border-color: var(--av-inversed-primary);
    }
    &--color-white {
        border-color: var(--av-inversed-primary);
    }
    &--color-brand-primary {
        border-color: var(--av-brand-primary);
    }
    &--color-brand-secondary {
        border-color: var(--av-brand-secondary);
    }

    &--size-16 {
        width: 16px;
        height: 16px;
    }
    &--size-24 {
        width: 24px;
        height: 24px;
    }
    &--size-32 {
        width: 32px;
        height: 32px;
    }
    &--size-48 {
        width: 48px;
        height: 48px;
    }
    &--size-16, &--size-24 {
        border-width: 2px;
        animation: 0.4s linear 0s infinite normal none running rotate;
    }
    &--size-32, &--size-48 {
        border-width: 3px;
        animation: 0.5s linear 0s infinite normal none running rotate;
    }
}

@keyframes rotate {
    100% {
        transform: rotate(1turn) translateZ(0px);
    }
}
</style>
